import { FREE_SKU } from "@colossus/contracts";
import { skuName } from "../plan.ts";
import { m } from "../paraglide/messages.js";
import { SEED_LADDER, liftingTier } from "../upsell.ts";
import type { Gate } from "../upsell.ts";

const gateOf = (key: string): Gate =>
  SEED_LADDER.some((tier) => Object.hasOwn(tier.entitlement.limits, key))
    ? { limit: key, reach: 1 }
    : { grant: key };

const firstTierWith = (key: string | null): string | null =>
  key === null ? FREE_SKU : liftingTier(SEED_LADDER, gateOf(key));

export const offered = (key: string | null): boolean => firstTierWith(key) !== null;

export const availableBadge = (key: string | null): string | null => {
  const sku = firstTierWith(key);
  if (sku === null) return null;
  return sku === FREE_SKU ? m.products_plan_every() : skuName(sku);
};

export const planBadge = (key: string | null): string => {
  const badge = availableBadge(key);
  if (badge === null) throw new Error(`${key} is granted on no tier`);
  return badge;
};

export const paidBadge = (key: string | null): string | null =>
  firstTierWith(key) === FREE_SKU ? null : planBadge(key);
